import DeletePopover from './DeletePopover';

export default DeletePopover;
